
// Vue
import Vue from 'vue';
import { Mixin } from 'vue-mixin-decorator';

// Store
import StoreModule from '@/store/index';
import { RouteConsts } from '@/routes/route';

@Mixin
export default class BaseComponent extends Vue {
  get store() {
    return StoreModule;
  }

  get routes() {
    return RouteConsts;
  }
}
